import { useMemo } from 'react';

export default function useGridFilterSources({
  disableColumnFilter,
  parentFilterModel,
  persistedFilterModel,
  validColumnFields,
}) {
  const effectiveFilterModel = useMemo(() => {
    if (disableColumnFilter) {
      return undefined;
    }

    const parentHasItems = parentFilterModel?.items?.length > 0;
    const model = parentHasItems
      ? parentFilterModel
      : (persistedFilterModel ?? parentFilterModel);

    if (!model || !model.items) {
      return model;
    }

    const sanitizedItems = model.items.filter((item) => {
      if (!item.field) return true;
      return validColumnFields.has(item.field);
    });

    if (sanitizedItems.length === model.items.length) {
      return model;
    }

    const { quickFilterValues, ...rest } = model;
    return {
      ...rest,
      items: sanitizedItems,
      ...(quickFilterValues ? { quickFilterValues } : {}),
    };
  }, [
    disableColumnFilter,
    parentFilterModel,
    persistedFilterModel,
    validColumnFields,
  ]);

  return {
    effectiveFilterModel,
  };
}
